import moment from 'moment-timezone';
import 'moment/locale/es';

const BOGOTA = 'America/Bogota';
export const VIDEO_ACCESS_MINUTES_BEFORE = 10;
const VIDEO_ACCESS_HOURS_AFTER = 4;

/**
 * @param {string|Date|moment.Moment} appointmentDate - Fecha UTC de la cita
 * @param {Date} [now]
 */
export const getVideoAccessStatus = (appointmentDate, now = new Date()) => {
    if (!appointmentDate) {
        return {
            canAccess: false,
            code: 'INVALID_DATE',
            message: 'No se pudo validar la hora de la cita.',
        };
    }

    const appointmentLocal = moment.utc(appointmentDate).tz(BOGOTA);
    if (!appointmentLocal.isValid()) {
        return {
            canAccess: false,
            code: 'INVALID_DATE',
            message: 'La fecha de la cita no es válida.',
        };
    }

    const nowLocal = moment(now).tz(BOGOTA);
    const opensAt = appointmentLocal.clone().subtract(VIDEO_ACCESS_MINUTES_BEFORE, 'minutes');
    const closesAt = appointmentLocal.clone().add(VIDEO_ACCESS_HOURS_AFTER, 'hours');

    if (nowLocal.isBefore(opensAt)) {
        moment.locale('es');
        const formattedOpensAt = opensAt.format('dddd, DD [de] MMMM [a las] h:mm a');
        const capitalized = formattedOpensAt.charAt(0).toUpperCase() + formattedOpensAt.slice(1);
        return {
            canAccess: false,
            code: 'TOO_EARLY',
            opensAt: opensAt.toISOString(),
            message: `La videoconsulta estará disponible 10 minutos antes de la cita (${capitalized}). Puedes firmar el consentimiento con anticipación desde Teleconsultas.`,
        };
    }

    if (nowLocal.isAfter(closesAt)) {
        return {
            canAccess: false,
            code: 'WINDOW_CLOSED',
            message: 'El acceso a la videoconsulta ya no está disponible para este horario. Contacta a soporte si necesita reprogramar.',
        };
    }

    return { canAccess: true, code: 'OK' };
};

export const hasHistoriaClinicaDocument = (documentsSummary) =>
    Array.isArray(documentsSummary) &&
    documentsSummary.some((doc) => doc.key === 'historiaClinica' && doc.url);
